import Client from '../../../utils/ClientVOIM';
import { ACTION_TYPES } from '../../../utils/Constants';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import URL from '../../../utils/URL';
import { myLog } from '../../../utils/Utility';

// Dashboard Action
export function getBranchAdminSummary(callBack) {
    return function (dispatch) {
        Client.get(URL.BRANCH_ADMIN.DASHBOARD, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
}

//
export const getUsersList = (values, callBack) => {
    return function (dispatch) {
        Client.get(URL.COMMON_ENDPOINT.USERLIST, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.USER_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

//
export const getVisitStudentId = (value, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.GETVISITSBYSTUDENTID}`, value, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT_VISITS,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

export const getSubCategoryReport = (values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.GET_SUBCATEGORY_REPORT}/${values.studentId}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT_VISITS,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};
export const getEducatorReport = (values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.GET_EDUCATOR_REPORT}/${values.studentId}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT_VISITS,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

export const getStudentHistory = (values, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.BRANCH_ADMIN.GET_STUDENT_HISTORY}/${values.studentId}/history`,
            values,
            true
        )
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT_VISITS,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

export function submitAddNotes(values, callBack) {
    return function (dispatch) {
        Client.post(URL.COMMON_ENDPOINT.STUDENT_ADD_NOTES, values, true)
            .then((response) => {
                myLog('====Reject Cancel response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====Reject tCancel error===????', error);
                callBack(false);
            });
    };
}

export function getAddNotes(id, values, callBack) {
    return function (dispatch) {
        Client.get(`${URL.COMMON_ENDPOINT.STUDENT_ADD_NOTES}?id=${id}`, values, true)
            .then((response) => {
                myLog('====Reject Cancel response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====Reject tCancel error===????', error);
                callBack(false);
            });
    };
}

// Session Cancelation
export const getCancellationList = (value, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.CANCELATION_REQUEST_LIST}`, value, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_SESSION_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Session List error===????', error);
                callBack(false);
            });
    };
};

//
export function appointmentCancel(values, callBack) {
    return function (dispatch) {
        Client.DELETENEW(URL.BRANCH_ADMIN.CANCEL_SESSION, values, true)
            .then((response) => {
                myLog('====appointmentCancel response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====appointmentCancel error===????', error);
                callBack(false);
            });
    };
}

//
export function rejectSessionRequest(values, callBack) {
    return function (dispatch) {
        Client.put(URL.BRANCH_ADMIN.REJECT_SESSION_REQUEST, values, true)
            .then((response) => {
                myLog('====Reject Cancel response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====Reject tCancel error===????', error);
                callBack(false);
            });
    };
}

// Below are session creation Actions
export const getSessionSubjectList = (values, callBack) => {
    return function (dispatch) {
        Client.get(URL.BRANCH_ADMIN.GET_SUBJECT_LIST, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

//
export const getSessionSubCategoryList = (id, values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.GET_SUB_CATEGORY_LIST}/${id}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

//
export const getEducatorsBySubjectAndSubcategoryId = (
    subjectId,
    subcategoryId,
    values,
    callBack
) => {
    return function (dispatch) {
        Client.get(
            `${
                URL.BRANCH_ADMIN.GET_TUTOR_LIST
            }/${subjectId}/category/${subcategoryId}?sessionType= ${2}`,
            values,
            true
        )
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

//
export const getEducatorAvailablityDays = (educatorId, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.COMMON_ENDPOINT.GET_EDUCATOR_AVAILABILITY_DAYS}?id=${educatorId}`,
            {},
            true
        )
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

//
export const getEducatorAvailability = (educatorId, date, callBack) => {
    const searchParams = new URLSearchParams(window.location.search);
    let payload = {};
    if (searchParams.get('studentUserId')) {
        payload = {
            studentUserId: searchParams.get('studentUserId'),
        };
    }
    return function (dispatch) {
        Client.get(
            `${URL.BRANCH_ADMIN.GET_EDUCATOR_AVAILABILITY}${educatorId}/date/${date}`,
            payload,
            true
        )
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

//
export const getAvailabeStudents = (values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.GET_AVAILABE_STUDENTS}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

//
export const createSession = (values, callBack) => {
    return function (dispatch) {
        Client.post(`${URL.BRANCH_ADMIN.CREATE_SESSION}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

//
export const createClassRoomSession = (data, callBack) => {
    return function (dispatch) {
        Client.post(URL.COMMON_ENDPOINT.CREATE_CLASSROOM_SESSION, data, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Create Classroom Session error===????', error);
            });
    };
};

// session list
export const getBranchAdminSessionList = (value, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.GET_BRANCH_ADMIN_SESSSION_LIST}`, value, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Branch Admin Session List error===????', error);
                callBack(false);
            });
    };
};

export const getSessionSummaryChatWithPagination = (visitId, values, callback) => {
    return () => {
        Client.getV2(`${URL.BRANCH_ADMIN.GET_SESSSION_LIST}/${visitId}/chat`, values, true)
            .then((response) => {
                myLog('====getSessionSummaryChatWithPagination ===::::response', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    callback(response);
                }
            })
            .catch((error) => {
                myLog('====getSessionSummaryChatWithPagination ==?????error', error);
                callback(false);
            });
    };
};

//
export const updateClassRoomSession = (data, callBack) => {
    return function (dispatch) {
        Client.put(URL.COMMON_ENDPOINT.CREATE_CLASSROOM_SESSION, data, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Create Classroom Session error===????', error);
            });
    };
};

//
export const fetchStudentAttendance = (values, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.COMMON_ENDPOINT.FETCH_STUDENT_ATTENDANCE}/${values.sessionId}/students`,
            values,
            true
        )
            .then((response) => {
                myLog('====fetch student attendance response===::::', response.response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====fetch student attendance error===????', error);
                callBack(false);
            });
    };
};
export const fetchBroadcastStudentDetails = (id, sessionId, values, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.BRANCH_ADMIN.GET_AVAILABE_LEVEL3_STUDENTS}/?visitId=${sessionId}`,
            values,
            true
        )
            .then((response) => {
                myLog('====fetch student attendance response===::::', response.response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====fetch student attendance error===????', error);
                callBack(false);
            });
    };
};
export const levelWiseBroadcastStudentDetails = (sessionId, values, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.BRANCH_ADMIN.GET_AVAILABE_LEVEL3_STUDENTS}/?visitId=${sessionId}`,
            values,
            true
        )
            .then((response) => {
                myLog('====fetch student attendance response===::::', response.response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====fetch student attendance error===????', error);
                callBack(false);
            });
    };
};
// get educator list on the dashboard page
export const getEducatorsReports = (values, callBack) => {
    return function () {
        Client.get(URL.BRANCH_ADMIN.DASHOARD_EDUCATORS_REPORTS, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                callBack(false);
            });
    };
};
